import React from 'react'
import Link from 'gatsby-link'
import { Helmet } from "react-helmet";

import { Col, Button, Form, FormGroup, Label, Input, FormText, InputGroup, InputGroupAddon } from 'reactstrap';

import Block from '../components/block';
import Title from '../components/my-title';

import BlockCover from '../components/block-cover';
import ContactImage from '../assets/contact.jpg';

import data from '../data';

const Architecte = () => (
  <div>
    <Helmet>
      <title>Architectes, partenaires : étudions notre prochaine collaboration</title>
      <meta name="description" content="Nous travaillons en totale harmonie avec vos équipes dans la maîtrise parfaite de notre métier." />
    </Helmet>
    <BlockCover
      backgroundUrl={ContactImage}
      title="Je suis architecte"
      repeatedTitle={true} />

    <Block hasDecoration className="block-grey-background">
      <Title>J'ai un projet</Title>
      <p className="light fs-16 lh-23 text-align-center mb-4">
        Didier Bré travaille en parfaite harmonie avec des<br />architectes et des partenaires de renom, pour créer<br />ensemble les meubles qui vous ressemblent.
      </p>

      <div className="row justify-content-md-center mb-5">
        <div className="col-md-5">
          <div className="row no-gutters">
            <div className="col-md-6 text-align-center">
              <p className="bold fs-16 mb-0">Les architectes :</p>
              <a href="http://www.santillane-design.com/" target="_blank" className="color-red light fs-16 mb-0">Santillane Design</a><br />
              <p className="color-red light fs-16 mb-0">Stéphanie Favre-Winkler</p>
              <p className="color-red light fs-16 mb-0">Halabama J. Luc Baussant</p>
            </div>
            <div className="col-md-6 text-align-center">
              <p className="bold fs-16 mb-0">Les partenaires :</p>
              <a href="https://www.laparqueterienouvelle.fr/" target="_blank" className="color-red light fs-16 mb-0">La Parqueterie Nouvelle</a><br />
              <a href="https://www.lmcstore.com/fr/" target="_blank" className="color-red light fs-16 mb-0">LMC Store</a>
            </div>
          </div>
        </div>
      </div>

      <Form method="post" data-netlify="true" data-netlify-honeypot="bot-field" name="architecte">
        <input type="hidden" name="form-name" value="architecte" />
        <p className="hidden">
          <label>Don’t fill this out: <input name="bot-field" /></label>
        </p>

        <div className="row justify-content-md-center">
          <div className="col-md-5">
            <FormGroup>
              <Input type="text" name="cabinet" id="cabinet" placeholder="Cabinet" />
            </FormGroup>
            <FormGroup>
              <Input type="text" name="name" id="name" placeholder="Nom, prénom" />
            </FormGroup>
            <FormGroup>
              <Input type="email" name="email" id="email" placeholder="Adresse email" />
            </FormGroup>
            <FormGroup>
              <Input type="select" name="project" id="project">
                <option disabled selected>Projet</option>
                {data.default.map((item, index) => (
                  <option key={index} value={item.title}>{item.title}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <InputGroup>
                <Input placeholder="Zone géographique du chantier" type="text" />
                <InputGroupAddon>
                  <img src="/locate.svg" alt="Localisation" />
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
            <FormGroup row>
              <Label for="date" sm={6}>Date estimée du projet :</Label>
              <Col sm={6}>
                <Input type="date" name="date" id="date" placeholder="JJ/MM/AAAA" />
              </Col>
            </FormGroup>

            <div className="text-align-center">
              <button type="submit" className="btn btn-primary btn-big btn-min-width-300 mt-3">
                Envoyer
              </button>
            </div>

            <p className="color-grey fs-12 light mt-3 text-align-center">* Délai de réponse sous 72h</p>
          </div>
        </div>
      </Form>
    </Block>
  </div>
)

export default Architecte



// WEBPACK FOOTER //
// ./src/pages/architecte.js